function formatNumberWithZeros(number, total) {
    const totalDigits = total.toString().length;
    return number.toString().padStart(totalDigits, '0');
}

export default formatNumberWithZeros